import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {logoutRequest, selectRoleRequest} from "../../redux/actions/authenticationActions";

const LogoutForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authToken = useSelector(state => state.authentication.authToken);
    const isLoadingLogout = useSelector(state => state.authentication.loading.logout);

    useEffect(() => {
        if (authToken && !isLoadingLogout) {
            localStorage.removeItem('authToken');
            if (localStorage.getItem('selectedRole')) {
                localStorage.removeItem('selectedRole');
            }
            dispatch(logoutRequest());
            dispatch(selectRoleRequest({ selectedRole: ""}));
        }
        if (!authToken) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('selectedRole');
            navigate('/');
        }
    }, [navigate, dispatch, authToken, isLoadingLogout]);

    return null;
};

export default LogoutForm;
